import {Pipe, PipeTransform} from '@angular/core';
import {DamageReportDamageWeightEnum} from 'src/packages/damage-reporting/data/models/damage-report.damage.weight.enum';

/**
 * An Angular pipe that converts a numeric damage weight value
 * (from the {@link DamageReportDamageWeightEnum}) into a localized
 * human-readable string (e.g., "Leicht", "Mittel", etc.).
 * Intended for use in templates, providing user-friendly labels for damage weights.
 */
@Pipe({
    name: 'damageWeight',
    standalone: true,
})
export class DamageWeightPipe implements PipeTransform {
    /**
     * Converts a damage weight value (from {@link DamageReportDamageWeightEnum})
     * to its corresponding localized label. If the value does not match one of
     * the known weights, it defaults to "Unbekannt".
     *
     * @param value - The numeric weight value to transform.
     * @returns A localized string describing the damage weight.
     *
     * @example
     * ```html
     * <!-- Template usage -->
     * {{ someDamageWeightValue | damageWeight }}
     * ```
     */
    transform(value: number): string {
        switch (value) {
            case DamageReportDamageWeightEnum.LIGHT:
                return $localize`Leicht`;
            case DamageReportDamageWeightEnum.MEDIUM:
                return $localize`Mittel`;
            case DamageReportDamageWeightEnum.HEAVY:
                return $localize`Schwer`;
            case DamageReportDamageWeightEnum.TOTAL:
                return $localize`Totalschaden`;
            default:
                return $localize`Unbekannt`;
        }
    }
}
